import React, { useState } from 'react'
import { useEffect } from 'react'
import {RunnerUpHeader, Select, TableWork } from '../../../ui'
import Button from '../../../library/components/Button'
import InputField from '../../../library/components/InputField'
import Modal from '../../../library/components/Modal/modal'
import Table from '../../../ui/datatable/DataTable'
import {
  useMasterDataUserUpdateMutation,
  useGetAllUserQuery,
  useGetUserByIdQuery,
  useUnlockUserMutation,
} from '../../../services/User_management/userService'
import { Validators } from '../../../library/utilities/Validator'
import {
  FILED_IS_REQUIRED,
  ENTER_VALID_EMAIL,
  ENTER_NAME,
  ENTER_DESIGNATION,
  ENTER_VALID_MOBILE,
  EDIT,
} from '../../../constants/constants'
import '../../../css/common.css'
import '../index.css'
import { ALERT_TYPE_SUCCESS , ALERT_TYPE_ERROR} from '../../../constants/constants'
import { useDispatch } from 'react-redux'
import { createAlert } from '../../../features/alert/alerts'
import { downloadPdfForMultipleTable, parseJwt } from '../../utilities/utils'
import LeftMenu from '../../AnalyticsModule/Left'
import pdfIcon from '../../../dashboardicon/pdfsvg.svg'
import excelIcon from '../../../dashboardicon/excel.svg'
import { downloadExcelFile, downloadPdfFile } from '../../utilities/utils'
import CustomModal from '../../../library/components/Modal/modal'
import ConfirmationModal from '../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal';
import VerifytOtp from './VerifyOtp'
import { useSendotpMutation as sendOtpForEciAndCeo} from '../../../services/ERO_management/otpservice';
import { useSendotpMutation as sendOtpForNodal, useGetUserNameQuery} from '../../../services/User_management/otpService';
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'


const UserList = () => {
  const mobileNo = parseJwt(localStorage?.access_token)?.phone_number
  const officerId = parseJwt(localStorage?.access_token)?.preferred_username 
  let userLognType = localStorage.userrole
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
  const [userId, setuserId] = useState('')
  const [reportName, setReportName] = useState('')
  const SheetName = reportName;
  const [skip, setSkip] = useState(true)
  const [isVisible, setisVisible] = useState(false)
  const [data, setData] = useState([])
  const [nodalMobileNumber,setNodalMobileNumber]=useState("");
  const [errorValue, setErrorValue] = useState({})
  const [VerifyModal,setVerifyModal] = useState(false)
  const [allUserTableList, setAllUserTableList] = useState([])
  const [pdfFileTableData, setPdfFileTableData] = useState([])
  const [runnerUpHeaderLabel, setRunnerUpHeaderLabel] = useState()

  const [otpsendNodal] = sendOtpForNodal()
  const [otpsend] = sendOtpForEciAndCeo()
  const [userName,setUserName]=useState("")
  const {data:getUserName, isloading} = useGetUserNameQuery("",{skip:localStorage.userrole =="ro"})
  const Userdata = useGetUserByIdQuery(userId, { skip })
  const [UserUpdate] = useMasterDataUserUpdateMutation()
  const dispatch = useDispatch()
  const { data: AllUser, refetch } = useGetAllUserQuery(userLognType)
  const [unLockUser,datap] = useUnlockUserMutation()
  
const headingAC =[
  'S.No',
  'User Type',
  'User ID',
  'District No. & Name',
  'AC No. & Name',
  'User Name',
  'Designation',
  'Password Set By User',
  'Mobile No.',
  'Email',
]

const headingpc =[
  'S.No',
  'User Type',
  'User ID',
  'District No. & Name',
  'PC No. & Name',
  'User Name',
  'Designation',
  'Password Set By User',
  'Mobile No.',
  'Email',
]
useEffect(()=>{
  if(datap.isSuccess){
    onSuccess("User Unlocked Successfully")
  }
},[datap])

  useEffect(()=>{
    if(!isloading){
setUserName(getUserName?.payload)
    }
  },[getUserName])

  useEffect(() => {
    if (localStorage.userrole === 'eci' ||localStorage.userrole === 'epba' ||localStorage.userrole === 'epbr')
    {
      // setReportName('List of Nodal Officers')
      // setRunnerUpHeaderLabel('List of Nodal Officers')
      setReportName('List of Returning Officers')
      setRunnerUpHeaderLabel('List of Returning Officers')
    } 
    else if (localStorage.userrole === 'ceo' ||localStorage.userrole === 'ceoa') 
    {
      setRunnerUpHeaderLabel('List of Returning officers and Counting Supervisor')
    } 
    else if (localStorage.userrole === 'ro') 
    {
      setRunnerUpHeaderLabel('List of Counting Supervisor')
    } 
    else 
    {
      setReportName('List of Record and Unit Officers')
      setRunnerUpHeaderLabel('List of Record and Unit Officers')
    }
  }, [])

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: 'Success',
      }),
    )
  }

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Reject",
      })
    );
  };

  const getErrorValue = (key, value) => {
    setErrorValue((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  const columns1 = [
    {
      Header: 'S.No',
      accessor: 'S_No',
    },
    {
      Header: 'User Type',
      accessor: 'User_Type',
    },
    {
      Header: 'User ID',
      accessor: 'User_ID',
    },
    {
      Header: 'District No. & Name',
      accessor: 'District_Cd',
    },
    {
      Header: 'AC/PC No. & Name',
      accessor: 'Contituency_Number',
    },
    {
      Header: 'User Name',
      accessor: 'User_Name',
    },
    {
      Header: 'Designation',
      accessor: 'User_Designation',
    },
    {
      Header: 'Password Set By User',
      accessor: 'is_first_time_login',
    },
    {
      Header: 'Mobile No.',
      accessor: 'User_Mobile',
    },
    {
      Header: 'Email',
      accessor: 'User_Email',
    },
    {
      Header: 'Edit',
      accessor: 'Action',
    },
    {
      Header: 'Unlock User',
      accessor: 'Unlock',
    },
  ]
  const columns2 = [
   {
      Header: 'S.No',
      accessor: 'S_No',
    },
    {
      Header: 'User ID',
      accessor: 'User_ID',
    },
     {
      Header: 'State Name',
      accessor: 'State_name',
    },
    {
      Header: 'District No. & Name',
      accessor: 'District_Cd',
    },
    {
      Header: 'AC/PC No.',
      accessor: 'Contituency_Number',
    },
    {
      Header: 'AC/PC Name',
      accessor: 'Contituency_Name',
    },
    {
      Header: 'User Name',
      accessor: 'User_Name',
    },
    {
      Header: 'Designation',
      accessor: 'User_Designation',
    },
    {
      Header: 'Password Set By User',
      accessor: 'is_first_time_login',
    },
      {
      Header: 'Last Login By User',
      accessor: 'last_login_time',
    },
    {
      Header: 'Mobile No.',
      accessor: 'User_Mobile',
    },
    {
      Header: 'Email',
      accessor: 'User_Email',
    },
  ]
  const pdfExcelList = {
    headCeo: [
      'S.No',
      'User Type',
      'User ID',
      'District No. & Name',
      'AC/PC No. & Name',
      'User Name',
      'Designation',
      'Password Set By User',
      'Mobile No.',
      'Email',
    ],
  
    otherHeadEci: [
      'S.No',
      'User ID',
      'State Name',
      'District No. & Name',
      'AC/PC No',
      'AC/PC Name',
      'User Name',
      'Designation',
      'Password Set By User',
      'Last Login By User',
      'Mobile No.',
      'Email',
    ],
  }
  
  const onUpdate = async () => {
      const isUpload = await UserUpdate({
        userId: data.UserId,
        userType: data.UserType,
        userName: data.Name,
        userDesignation: data.Designation,
        userMobile: data.Mobile,
        userEmail: data.Email,
        userLognType: localStorage.userrole,
      })
      if (isUpload.data) {
        onSuccess(isUpload.data.message)
        setisVisible(false)
        refetch()
      }
      if (isUpload.error) {
        alert(isUpload.error.data.error)
      }
  }
  useEffect(() => {
    {
      Userdata.data &&
        setData({
          UserType: Userdata.data.payload[0].userType,
          UserId: Userdata.data.payload[0].userId,
          Name: Userdata.data.payload[0].userName,
          Designation: Userdata.data.payload[0].userDesignation,
          Mobile: Userdata.data.payload[0].userMobile,
          Email: Userdata.data.payload[0].userEmail,
        })
    }
  }, [Userdata])

  const userEdit = (e) => {
    setSkip(false)
    setisVisible(true)
    var temp = e.currentTarget.name
    setuserId(temp)
  }

  useEffect(() => {
    if (AllUser) {
      let allUserList = []
      let payLoad = AllUser?.payload
      if (localStorage.userrole === 'ceo'||localStorage.userrole === 'ceoa'||localStorage.userrole === 'ro') {
        setTotalNoOfRecords(payLoad?.adminDataList?.length)
        preparePdfDataForCEO(payLoad)
        payLoad?.adminDataList?.map((item, i) => {
          allUserList.push({
            S_No: i + 1,
            User_Type: item.userType,
            User_ID: item.userId,
            District_Cd: `${item.districtCd} - ${item.districtName }`,
            Contituency_Number: `${item.constituencyNumber} - ${item.constName}`,
            User_Name: item.userName,
            User_Designation: item.userDesignation,
            is_first_time_login:item.firstTimeLogin,
            User_Mobile: item.userMobile,
            User_Email: item.userEmail,
            Action: item?.userType!=="RO" ? (
              <button
                className="UserEditButton"
                name={item.userId}
                onClick={userEdit}
              >
                <i className="fa-solid fa-pencil edit-icon" />
                {EDIT}
              </button>
            ):<i className="fa-solid fa-circle-info text-center" 
               style={{marginLeft:"15px",color:"blue",fontSize:"18px"}}
               data-bs-toggle="tooltip" 
               data-bs-placement="bottom" 
               title="To update the RO details, go to the ECINet Portal.">
            </i>,
            Unlock: item?.userType !=="RO"&&(
              <button
                className="UserEditButton"
                name={item.userId}
                onClick={()=>{unLockUser({userId:item?.userId})}}
              >
                <i className="fa-solid fa-unlock-keyhole edit-icon" />
                Unlock
              </button>
            ),
          })
        })
      } else {
        setTotalNoOfRecords(payLoad?.length)
        payLoad?.map((item, i) => {
          // allUserList.push({
          //   S_No: i + 1,
          //   User_ID: item.userId,
          //   Force_Name: item.forceName,
          //   User_Name: item.userName,
          //   User_Designation: item.userDesignation,
          //   is_first_time_login:item.firstTimeLogin,
          //   User_Mobile: item.userMobile,
          //   User_Email: item.userEmail,
          //   Action: (
          //     <button
          //       className="UserEditButton"
          //       name={item.userId}
          //       onClick={userEdit}
          //     >
          //       <i className="fa-solid fa-pencil edit-icon" />
          //       {EDIT}
          //     </button>
          //   ),
          // })
               allUserList.push({
            S_No: i + 1,
            User_ID: item.userId,
            State_name: item.stateName,
            District_Cd: `${item.districtCd} - ${item.districtName }`,
            Contituency_Number: item.constituencyNumber,
            Contituency_Name: item.constName,
            User_Name: item.userName,
            User_Designation: item.userDesignation,
            is_first_time_login:item.firstTimeLogin,
            last_login_time:item.lastLoginTime,
            User_Mobile: item.userMobile,
            User_Email: item.userEmail,
          })
        })
        
      }
      setAllUserTableList(allUserList)
      // setNodalMobileNumber(AllUser?.refId)
    }
  }, [AllUser])

  const preparePdfDataForCEO = (payLoad) => {
    let genAcList = payLoad?.adminDataList?.filter(
      (item) => item.electionType === 'GEN' && item.constituencyType === 'AC',
    )
    let genPcList = payLoad?.adminDataList?.filter(
      (item) => item.electionType === 'GEN' && item.constituencyType === 'PC',
    )
    let byeAcList = payLoad?.adminDataList?.filter(
      (item) => item.electionType === 'BYE' && item.constituencyType === 'AC',
    )
    let byePcList = payLoad?.adminDataList?.filter(
      (item) => item.electionType === 'BYE' && item.constituencyType === 'PC',
    )
    setReportName('List of Returning officers and Counting Supervisor')

    let heading1 = null
    let heading2 = null
    let data1 = []
    let data2 = []

    if (genAcList && genAcList.length > 0) {
      heading1 = 'General Election to Legislative Assembly of '
      data1 = genAcList
    }
    if (genPcList && genPcList.length > 0) {
      heading2 = 'General Election to Lok Sabha of '
      data2 = genPcList
    }

    if (byeAcList && byeAcList.length > 0) {
      heading1 = 'Bye Election to Legislative Assembly of '
      data1 = byeAcList
    }
    if (byePcList && byePcList.length > 0) {
      heading2 = 'Bye Election to Lok Sabha of '
      data2 = byePcList
    }
    let pdfTableData = []
    let pdfData1 = []
    let pdfData2 = []
    data1.map((item, i) => {
      pdfData1.push({
        S_No: i + 1,
        User_Type: item.userType,
        User_ID: item.userId,
        District_Cd: `${item.districtCd} - ${item.districtName}`,
        Contituency_Number: `${item.constituencyNumber}-${item.constName}`,
        User_Name: item.userName,
        User_Designation: item.userDesignation,
        is_first_time_login:item.firstTimeLogin,
        User_Mobile: item.userMobile,
        User_Email: item.userEmail,
        Action: (
          <button
            className="UserEditButton"
            name={item.userId}
            onClick={userEdit}
          >
            <i className="fa-solid fa-pencil edit-icon" />
            {EDIT}
          </button>
        ),
      })
    })
    data2.map((item, i) => {
      pdfData2.push({
        S_No: i + 1,
        User_Type: item.userType,
        User_ID: item.userId,
        District_Cd: `${item.districtCd} - ${item.districtName}`,
        Contituency_Number: `${item.constituencyNumber}-${item.constName}`,
        User_Name: item.userName,
        User_Designation: item.userDesignation,
        is_first_time_login:item.firstTimeLogin,
        User_Mobile: item.userMobile,
        User_Email: item.userEmail,
        Action: (
          <button
            className="UserEditButton"
            name={item.userId}
            onClick={userEdit}
          >
            <i className="fa-solid fa-pencil edit-icon" />
            {EDIT}
          </button>
        ),
      })
    })
    if (heading1) {
      heading1 += `${payLoad?.stateName}, ${payLoad?.cutOfDateYear}`
      pdfTableData.push({ heading: heading1, data: pdfData1 ,header:headingAC})
    }
    if (heading2) {
      heading2 += `${payLoad?.stateName}, ${payLoad?.cutOfDateYear}`
      pdfTableData.push({ heading: heading2, data: pdfData2 ,header:headingpc})
    }
    setPdfFileTableData(pdfTableData)
  }

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }
const handleOpen=()=>{
  setShowConfirmationPopup(false);
  if (
    errorValue.Designation?.error ||
    errorValue.Email?.error ||
    errorValue.Mobile?.error ||
    errorValue.Name?.error
  ) 
  {
    return
  } 
  if(localStorage.userrole==="eci" || localStorage.userrole==="ceo" || localStorage.userrole==="epba" || localStorage.userrole==="epbr" || localStorage.userrole==="ceoa")
  {
    otpsend({
      userName: userName,
      userCreation: false,
    }).unwrap()
    .then((res)=>{
      if(res?.message ==="OTP sent.")
      {
      setVerifyModal(true)
      }
    }).catch((error)=>{
        onReject(error?.data?.message)
    })
  }
  else
  {
    otpsendNodal({
      userId: officerId,
    }).unwrap()
    .then((res)=>{
      if(res?.message==="OTP sent.")
      {
      setVerifyModal(true)
      }
    }).catch((error)=>{
      onReject(error?.data?.message)
    })
  }
  

  
}
  return (
    <LeftMenu>
      <div className="container box shadow ">
        <RunnerUpHeaderNew
          title={runnerUpHeaderLabel}
          state={(localStorage.userrole==="eci" || localStorage.userrole==="epba" || localStorage.userrole==="epbr" || localStorage.userrole==="nodal")?null:((<span
            >
            State: {AllUser?.payload?.stateName}{" "}
            </span>))
          
            }
        onPdfClick={() => {
                    if (localStorage.userrole === 'ceo' ||localStorage.userrole === 'ceoa' ||localStorage.userrole === 'ro' ) {
                      downloadPdfForMultipleTable(
                        reportName,
                        pdfExcelList.headCeo,
                        pdfFileTableData,
                      )
                    } else {
                      downloadPdfFile(
                        reportName,
                        pdfExcelList.otherHeadEci,
                        allUserTableList,
                      )
                    }
                  }}
         
            onExcelClick={() =>
                    downloadExcelFile(
                      reportName,
                      SheetName,
                      (localStorage.userrole === 'ceo'|| localStorage.userrole === 'ceoa'|| localStorage.userrole === 'ro')
                        ? pdfExcelList.headCeo
                        : pdfExcelList.otherHeadEci,
                        allUserTableList.map(({ Action,Unlock, ...rest }) => rest)
                        ,
                    )
                  }
             
        />
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={(localStorage.userrole === 'ceo' || localStorage.userrole === 'ceoa' || localStorage.userrole === 'ro') ? columns1 : columns2}
          emptyMessage="No Record Found"
          records
          data={allUserTableList?.length === 0 ? [] : allUserTableList}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
        {Userdata.data && data && (
          <Modal
            show={isVisible}
            className=""
            onClose={() => setisVisible(false)}
            modalTitle="Update User"
            size={600}
          >
            {
              <CustomModal
                className="confirmation_modal"
                show={showConfirmationPopup}
                onClose={() => {
                  setShowConfirmationPopup(false)
                }}
                size="500px"
                closeIcon={false}
                modalTitle={'Do you want to Update ?'}
                children={
                  <ConfirmationModal
                    // title="You want to delete this"
                    noOption={() => {
                      setShowConfirmationPopup(false)
                    }}
                    yesOption={handleOpen}
                  />
                }
              />
            }
            {
              <CustomModal
                className="confirmation_modal"
                show={VerifyModal}
                onClose={() => {
                  setVerifyModal(false)
                }}
                size="500px"
                closeIcon={false}
                modalTitle={'Do you want to Update ?'}
                children={
                  <VerifytOtp
                    onSuccess={()=>{setVerifyModal(false) 
                    onUpdate()}}
                    nodalMobileNumber={nodalMobileNumber}
                    userName={userName}
                  />
                }
              />
            }
            <div className="row">
              <div className="col-md-6">
                <label>User Type</label>
              </div>
              <div className="col-md-6">
                <Select
                  list={[{ label: '', vlaue: '' }]}
                  placeholder={data.UserType}
                  disabled={true}
                  selectClass="modal-select"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>User ID</label>
              </div>
              <div className="col-md-6">
                <Select
                  list={[{ label: '', vlaue: '' }]}
                  placeholder={data.UserId}
                  disabled={true}
                  selectClass="modal-select"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Name</label>
              </div>
              <div className="col-md-6">
                <InputField
                  name="Name"
                  required={true}
                  inputClass="col"
                  labelClass="col"
                  maxLength={160}
                  value={data.Name}
                  onChange={(val) => handleChange('Name', val)}
                  getError={(value) => getErrorValue('Name', value)}
                  validators={[
                    {
                      check: Validators.name,
                      message: ENTER_NAME,
                    },
                    {
                      check: Validators.required,
                      message: FILED_IS_REQUIRED,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Designation</label>
              </div>
              <div className="col-md-6">
                <InputField
                  name="Designation"
                  required={true}
                  inputClass="col"
                  type="text"
                  labelClass="col"
                  maxLength={50}
                  value={data.Designation}
                  onChange={(val) => handleChange('Designation', val)}
                  getError={(value) => getErrorValue('Designation', value)}
                  validators={[
                    {
                      check: Validators.nospecialReason,
                      message: "Please enter valid name",
                    },
                      {
                        check: Validators.required,
                        message: "Please enter the user designation",
                      },         
                  ]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Mobile No.</label>
              </div>
              <div className="col-md-6">
                <InputField
                  name="Mobile"
                  required={true}
                  inputClass="col"
                  labelClass="col"
                  maxLength={10}
                  value={data.Mobile}
                  onChange={(val) => handleChange('Mobile', val)}
                  getError={(value) => getErrorValue('Mobile', value)}
                  validators={[
                    {
                      check: Validators.mobile,
                      message: ENTER_VALID_MOBILE,
                    },
                    {
                      check: Validators.required,
                      message: FILED_IS_REQUIRED,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Email ID</label>
              </div>
              <div className="col-md-6">
                <InputField
                  name="Email"
                  required={true}
                  inputClass="col"
                  labelClass="col"
                  value={data.Email}
                  type="email"
                  onChange={(val) => handleChange('Email', val)}
                  getError={(value) => getErrorValue('Email', value)}
                  validators={[
                    {
                      check: Validators.emailCEODEO,
                      message: ENTER_VALID_EMAIL,
                    },
                    {
                      check: Validators.required,
                      message: FILED_IS_REQUIRED,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="row offset-6 pl-2">
              <Button
                value="update"
                onClick={() => setShowConfirmationPopup(true)}
                className="btn-class"
              />
            </div>
          </Modal>
        )}
      </div>
    </LeftMenu>
  )
}
export default UserList
